import { render, staticRenderFns } from "./InstitutionInfoTwo.vue?vue&type=template&id=12b9ab8c&scoped=true&"
import script from "./InstitutionInfoTwo.vue?vue&type=script&lang=ts&"
export * from "./InstitutionInfoTwo.vue?vue&type=script&lang=ts&"
import style0 from "./InstitutionInfoTwo.vue?vue&type=style&index=0&id=12b9ab8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b9ab8c",
  null
  
)

export default component.exports